const moduleName = 'file';

module.exports = () => {

	Array.from(document.querySelectorAll('.js-file')).forEach((self) => {
		if (self.dataset[moduleName + 'Init'] === 'true') return;
		self.dataset[moduleName + 'Init'] = true;

		const holder = self;
		const entry = holder.querySelector('.js-file-entry');
		const name = holder.querySelector('.js-file-name');
		const removeBtn = holder.querySelector('.js-file-remove');

		entry.addEventListener('change', () => {
			const fileName = event.target.value.split('\\').pop();

			name.innerHTML = fileName;
			holder.classList.add('_filled');
		});

		removeBtn.addEventListener('click', () => {
			entry.value = '';
			name.innerHTML = '';
			holder.classList.remove('_filled');
		});
	});

};